import * as headerBlock from '../header/index';

const alert = require('vue-strap').alert;

export default {
  name: 'login',
  components: { headerBlock, alert },
  props: [
    'onLogout'
  ],
  mounted() {
    this.getAuthProviders();
    this.checkSamlRedirect();
  },
  data() {
    return {
      authData: {
        loginInput: this.loginInput,
        passwordInput: this.passwordInput,
      },
      alertError: {
        text: 'Incorrect login or password',
        title: 'Error!',
        visible: false,
      },
      alertSuccess: {
        text: 'User created',
        title: 'Success!',
        visible: false,
      },
      alertWarning: {
        text: 'You seem to be logged in at another location. And was redirected to the login for security reasons.',
        title: 'Warning!',
        visible: false,
      },
      loginProviders: [],
      user: {},
      showLoginMain: false,
    };
  },
  methods: {
    // login($event, authData) {
    //   this.$emit('loginSend', [authData.loginInput, authData.passwordInput]);
    // },
    sendAuth() {
      this.$http.post('authorize/', { username: this.authData.loginInput, password: this.authData.passwordInput, app: 'cms' },
        {
          method: 'POST',
          headers: {},
        })
        .then((response) => {
          if (response.status !== 200) {
            this.alertError.text = 'Incorrect login or password';
            this.alertError.visible = true;
            return;
          }
          if (response.body.user && response.body.user.role === 'basic') {
            this.alertError.text = 'Access denied to basic user';
            this.alertError.visible = true;
            return;
          }
          this.$emit('onLogin', response.body.access_token, response.body.user);
        })
        .catch((response) => {
          if (response.status === 403) {
            this.alertError.text = 'Incorrect login or password';
          } else {
            this.alertError.text = `Error code ${response.status}`;
          }
          this.alertError.visible = true;
        });
    },
    getAuthProviders() {
      this.$http.get('auth_providers/',
        {
          method: 'GET',
          headers: {},
        })
      .then((response) => {
        if (response.status !== 200) {
          this.alertError.text = 'Can not get auth providers';
          this.alertError.visible = true;
          return;
        }
        this.loginProviders = response.body;
        localStorage.setItem('samlProviders', JSON.stringify(this.loginProviders));
      })
     .catch((response) => {
       this.alertError.text = `Can not get auth providers. Error code: ${response.status}`;
       this.alertError.visible = true;
     });
    },
    getAuthUser(token, userId) {
      this.$http.get(`users/${userId}/`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            this.alertError.text = 'Could not fetch User information';
            this.alertError.visible = true;
            return;
          }
          if (response.body && response.body.role === 'basic') {
            this.alertError.text = 'Access denied to basic user';
            this.alertError.visible = true;
            return;
          }
          this.user = response.body;
          this.$emit('onLogin', token, this.user);
        });
    },
    checkSamlRedirect() {
      let authed = this.$route.query.authorized;
      let idp = this.$route.query.idp;
      const token = this.$route.query.token;
      const userId = this.$route.query.id;
      this.$router.replace({ query: { '': '' } });
      authed = authed ? authed.toLowerCase() : '';
      idp = idp ? idp.toLowerCase() : '';
      if (authed === 'false') {
        if (idp) {
          this.forceSamlLogout(idp);
        }
        this.alertError.text = 'Incorrect login or password';
        this.alertError.visible = true;
        return;
      }
      if (token && userId) {
        this.getAuthUser(token, userId);
      }
    },
    checkSuffix() {
      const login = this.authData.loginInput;
      if (login.indexOf('@') > -1) {
        const userSuffix = login.split('@')[1];
        for (let i = 0; i < this.loginProviders.length; i++) {
          for (let ii = 0; ii < this.loginProviders[i].suffixes.length; ii++) {
            if (userSuffix === this.loginProviders[i].suffixes[ii]) {
              window.location.href = this.loginProviders[i].login_cms_url;
              return;
            }
          }
        }
      }
      this.showLoginMain = true;
    },
    forceSamlLogout(idp) {
      const providers = JSON.parse(localStorage.samlProviders);
      for (let i = 0; i < providers.length; i++) {
        if (providers[i].name.toLowerCase() === idp) {
          window.open(providers[i].logout_url, '_blank');
        }
      }
    },
  },
  computed: {

  },
  created() {
    if (this.$route.params.redirectedOnError) {
      setTimeout(() => (this.alertWarning.visible = true), 1);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/login/login.component.js